__turbopack_context__.v({
  "list": "total-product-set-module-scss-module__Y02a2q__list",
  "section": "total-product-set-module-scss-module__Y02a2q__section",
});
